// @flow
import {
  useQuery,
  useQueryClient,
  keepPreviousData,
} from '@tanstack/react-query';
import type {UseQueryReturn} from '@tanstack/react-query';
import {documentationSessionDocumentsList} from 'api/v2';
import type {DocumentationSessionDocumentsListParams} from 'api/v2';
import {useStores} from 'hooks/useStores';
import type {UISessionDocumentType} from '../model/types';
import {sessionDocumentKeys} from './keys';
import {resolveDocuments} from './resolveDocuments';

type SessionDocumentsPage = {
  count: number,
  next: string | null,
  previous: string | null,
  results: Array<UISessionDocumentType>,
};

// Fetches the paginated V2 session-documents list via the api-client. Org scope
// is applied through the X-Org-ID header, so only pagination/sort/filter params
// are passed. The flat results carry member/staff/typeOfService as UUIDs, so
// they're resolved to nested UI docs before the grid renders them.
export const useSessionDocuments = (
  params: DocumentationSessionDocumentsListParams,
): UseQueryReturn<SessionDocumentsPage, any> => {
  const {memberStore} = useStores();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: sessionDocumentKeys.list(params),
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const {data} = await documentationSessionDocumentsList(params);
      const results = await resolveDocuments(data.results, {
        memberStore,
        queryClient,
      });
      return {...data, results};
    },
  });
};
